import { toast } from 'sonner'
import { useTranslation } from '../i18n/client'

const useLogout = () => {
  const { t } = useTranslation()

  const logout = () => {
    if (process.env.NODE_ENV === 'development') {
      window.location.href = `${process.env.API_LOCALHOST_ORIGIN_URL}/auth/logout`
    } else {
      window.location.href = window.location.origin + '/auth/logout'
    }
    toast.success(t('User Logged Out'))
  }

  return logout
}

export default useLogout
